module.exports = __webpack_public_path__ + "img/TPV-L1-5-Pagina7 C.d425f4ff.png";